import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import UserContext from "../../Context/UserProvider";
import {
    Box,
    Container,
    Paper,
    Typography,
    Button,
    Stack,
    Alert,
    CircularProgress,
    Grid
} from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function LoginPage() {
    const { loginWithRedirect, isAuthenticated } = useAuth0();
    const navigate = useNavigate();
    const { userInfo, setUserInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/plan/dashboard"); // Redirect after successful login
        }
    }, [isAuthenticated, navigate]);

    async function handleLogin(email: string, password: string) {
        setLoading(true);
        setError("");

        try {
            const response = await fetchWithAuth('/auth/login', {
                method: 'POST',
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                throw new Error('Login failed');
            }

            const data = await response.json();
            setUserInfo(data);
            navigate('/dashboard');
        } catch (error) {
            console.error('Error during login:', error);
            setError('Invalid email or password');
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container 
            maxWidth={false}
            sx={{ 
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: {
                    xs: '100%',    // Full width on mobile
                    sm: '100%',    // Full width on tablet
                    md: '66.67%',  // 2/3 width on medium screens
                    lg: '33.33%',  // 1/3 width on large screens
                },
                mx: 'auto'
            }}
        >
            <Paper 
                elevation={0}
                sx={{
                    p: 4,
                    width: '100%',
                    borderRadius: 1
                }}
            >
                <Stack spacing={3} alignItems="center">
                    <Typography 
                        variant="h4" 
                        component="span"
                        sx={{ 
                            cursor: 'pointer',
                            fontFamily: 'Qualy',
                            fontWeight: 'bold'
                        }}
                        onClick={() => navigate("/")}
                    >
                        Evata
                    </Typography>

                    <Typography variant="body1" color="text.secondary">
                        Please log in
                    </Typography>

                    {errorMessage && (
                        <Alert severity="error" sx={{ width: '100%' }}>
                            {errorMessage}
                        </Alert>
                    )}

                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => loginWithRedirect()}
                        sx={{
                            py: 1.5,
                            textTransform: 'none',
                            fontSize: '1rem'
                        }}
                    >
                        Login
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}

export default LoginPage;
